import { createFileRoute } from '@tanstack/react-router';
import { RouteGuard } from '../../lib/route-guard.js';
import { BrandCreateForm } from '../../modules/brands/brand-create-form.js';

export const Route = createFileRoute('/brands/new')({
  component: NewBrandPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function NewBrandPage() {
  return (
    <RouteGuard route="/brands/new">
      <div>
        <BrandCreateForm />
      </div>
    </RouteGuard>
  );
}
